/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cancel_Done_Access_UntilInputs */

const en_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You'll have access until ${i?.date}.`)
};

const de_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast Zugang bis ${i?.date}.`)
};

const fr_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu auras acces jusqu'au ${i?.date}.`)
};

const es_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tendras acceso hasta ${i?.date}.`)
};

const it_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avrai accesso fino al ${i?.date}.`)
};

const nl_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je hebt toegang tot ${i?.date}.`)
};

const pl_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Masz dostep do ${i?.date}.`)
};

const fi_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sinulla on paaesy ${i?.date} asti.`)
};

const da_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har adgang indtil ${i?.date}.`)
};

const sv_cancel_done_access_until = /** @type {(inputs: Cancel_Done_Access_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har tillgång till ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "You'll have access until {date}." |
*
* @param {Cancel_Done_Access_UntilInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_done_access_until = /** @type {((inputs: Cancel_Done_Access_UntilInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Done_Access_UntilInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_done_access_until(inputs)
	if (locale === "fr") return fr_cancel_done_access_until(inputs)
	if (locale === "es") return es_cancel_done_access_until(inputs)
	if (locale === "it") return it_cancel_done_access_until(inputs)
	if (locale === "nl") return nl_cancel_done_access_until(inputs)
	if (locale === "pl") return pl_cancel_done_access_until(inputs)
	if (locale === "fi") return fi_cancel_done_access_until(inputs)
	if (locale === "da") return da_cancel_done_access_until(inputs)
	if (locale === "sv") return sv_cancel_done_access_until(inputs)
	return en_cancel_done_access_until(inputs)
});